import { useState } from "react";
import type { FormEvent } from "react";
import contactImage from "@/assets/landing/contact.webp";
import { toast } from "@/shared/components/toast";
import DotGrid from "./ui/dotGrid";
import Reveal from "./ui/reveal";

const emptyForm = {
  nombre: "",
  email: "",
  telefono: "",
  empresa: "",
  mensaje: "",
};

const inputClass =
  "font-display w-full rounded-md bg-[#eceef1] px-5 py-3.5 text-sm tracking-[0.06em] text-nodric-ink uppercase placeholder:text-nodric-blue focus:outline-none focus:ring-2 focus:ring-nodric-blue transition-shadow";

export default function ContactSection() {
  const [form, setForm] = useState(emptyForm);

  const update = (key: keyof typeof emptyForm) => (value: string) =>
    setForm((prev) => ({ ...prev, [key]: value }));

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    toast.success("Mensaje enviado. Te contactaremos muy pronto.");
    setForm(emptyForm);
  };

  return (
    <section
      id="contacto"
      className="relative overflow-hidden bg-gradient-to-b from-[#eef4ff] via-[#8fbcff] to-nodric-blue pt-20 md:pt-28"
    >
      <DotGrid color="rgba(255,255,255,0.35)" size={30} />

      <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-12">
        <Reveal>
          <h2 className="font-display mx-auto max-w-[30ch] text-center text-2xl leading-snug font-medium tracking-[0.06em] text-nodric-ink md:text-4xl">
            Quieres saber algo más de nosotros, entonces escríbenos para
            ayudarte
          </h2>
        </Reveal>

        <div className="relative mt-14 lg:w-[68%]">
          <Reveal delay={0.1}>
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <div className="grid gap-4 md:grid-cols-2">
                <input
                  required
                  className={inputClass}
                  placeholder="Nombre completo*"
                  value={form.nombre}
                  onChange={(e) => update("nombre")(e.target.value)}
                />
                <input
                  required
                  type="email"
                  className={inputClass}
                  placeholder="Email*"
                  value={form.email}
                  onChange={(e) => update("email")(e.target.value)}
                />
                <input
                  className={inputClass}
                  placeholder="Teléfono"
                  value={form.telefono}
                  onChange={(e) => update("telefono")(e.target.value)}
                />
                <input
                  className={inputClass}
                  placeholder="Empresa"
                  value={form.empresa}
                  onChange={(e) => update("empresa")(e.target.value)}
                />
              </div>

              <textarea
                required
                rows={8}
                className={`${inputClass} resize-none normal-case`}
                placeholder="Escribe tu mensaje aquí*"
                value={form.mensaje}
                onChange={(e) => update("mensaje")(e.target.value)}
              />

              <div className="mt-2 flex justify-center">
                <button
                  type="submit"
                  className="font-display cursor-pointer rounded-full bg-nodric-ink px-14 py-3.5 text-[11px] tracking-[0.2em] text-white uppercase transition-all duration-300 hover:scale-[1.02] hover:bg-black active:scale-[0.98]"
                >
                  Enviar mensaje
                </button>
              </div>
            </form>
          </Reveal>

        </div>
      </div>

      {/* Oversized wordmark bleeding behind the portrait */}
      <Reveal
        direction="left"
        delay={0.2}
        className="pointer-events-none absolute right-0 bottom-0 z-20 hidden w-[34%] max-w-[1060px] lg:block"
      >
        <img src={contactImage} alt="" className="w-full object-contain" />
      </Reveal>
      <div className="relative z-10 -mb-[1px] overflow-hidden">
        <h2 className="font-display w-full text-center text-[12.5vw] leading-[0.85] font-bold tracking-[-0.02em] whitespace-nowrap text-white select-none">
          Contáctanos
        </h2>
      </div>


    </section>
  );
}
